import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { qualification } from 'src/api';
import { companyInfo } from 'src/api';
import { message } from 'antd';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import Message from 'kts-scaffold-framework/component/Message';

class ModulesAction extends ActionBasic<ModulesState> {
    public getQualificationList = async () => {
        const res = await qualification.list(this);
        if (!res.er) {
            this.modulesState.qualificationList = res.res;
            this.setModulesState();
        }
    }

    public getQualificationInfo = async (option) => {
        const res = await qualification.info(this, option);
        if (!res.er) {
            this.modulesState.qualificationInfo = res.res;
            this.changeEditEndValue(res.res.endTime);
            this.changeEditStartValue(res.res.startTime);
            this.setModulesState();
        }
    }

    public uploadToken = async (options) => {
        const res = await companyInfo.uploadToken(this);
        if (!res.er) {
            this.modulesState.uploadTokenData = res.res;
        }
        this.setModulesState(this.modulesState);
    }

    public changeWatchVisible = (b: boolean) => {
        this.modulesState.watchVisible = b;
        this.setModulesState();
    }

    public createQualification = async (option) => {
        const res = await qualification.create(this, option);
        if (!res.er) {
            Message.success('创建资质成功');
            this.getQualificationList();
            return res;
        }
    }

    public hideAside = () => {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, {});
    }

    public getIndustryList = async () => {
        const res = await qualification.industryList(this);
        if (!res.er) {
            this.modulesState.industryList = res.res;
            this.setModulesState();
        }
    }

    public updateQualification = async (option) => {
        const res = await qualification.update(this, option);
        if (!res.er) {
            Message.success('修改资质成功');
            this.hideAside();
            this.getQualificationList();
        }
    }

    public deleteQualification = async (option) => {
        const res = await qualification.deleteQualificationInfo(this, option);
        if (!res.er) {
            Message.success('删除资质成功');
            this.getQualificationList();
            return res;
        }
    }

    public changeDeleteVisible = (b) => {
        this.modulesState.deleteVisible = b;
        this.setModulesState();
    }

    public changeWillDeleteQulification = (value) => {
        this.modulesState.willDeleteQualification = value;
        this.setModulesState();
    }

    public changeSnapImg = (uri) => {
        this.modulesState.snapImg = uri;
        this.setModulesState();
    }

    public changeModalImgsIs = (val) => {
        this.modulesState.modalImgIs = val;
        this.setModulesState();
    }

    public changeEditStartValue = (val) => {
        this.modulesState.editStartValue = val;
        this.setModulesState();
    }

    public changeEditEndValue = val => {
        this.modulesState.editEndValue = val;
        this.setModulesState();
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/Qualification/Modules.Action.ts